export default "__VITE_ASSET__b4c2ebcd__"